import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#050b14] py-12 border-t border-ocean-800" data-id="element-33">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-34">
        <div className="flex items-center gap-3" data-id="element-35">
          <div className="w-10 h-10 rounded-full overflow-hidden border border-ocean-800" data-id="element-36">
            <img src="https://cdn.magicpatterns.com/uploads/376XfgufppoCzctQV4w12y/bwc_temp_logo.jpg" alt="BWC Logo" className="w-full h-full object-cover" data-id="element-37" />
          </div>
          <span className="text-white font-bold text-lg" data-id="element-38">BWC Decking</span>
        </div>

        <div className="text-ocean-200 text-sm text-center md:text-left" data-id="element-39">
          &copy; {currentYear} BWC Boat Deck Restoration. All rights reserved.
        </div>

        <div className="flex items-center gap-4 text-sm font-medium text-ocean-200" data-id="element-40">
          <a href="tel:9542751630" className="hover:text-sun-400 transition-colors" data-id="element-41">
            (954) 275-1630
          </a>
        </div>
      </div>
    </footer>;
}